import { __decorate, __metadata } from "tslib";
import { appendClass, dispatchEvent, subscribe } from '@1inch-community/core/lit-utils';
import { ChainId } from '@1inch-community/models';
import '@1inch-community/ui-components/icon';
import '@1inch-community/ui-components/loaders';
import '@1inch-community/ui-components/marquee';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { when } from 'lit/directives/when.js';
import { fromEvent, tap } from 'rxjs';
import '../../balance-view';
import '../../token-icon';
import { tokenItemBaseStyle } from './token-item-base.style';
let TokenItemBaseElement = class TokenItemBaseElement extends LitElement {
    constructor() {
        super(...arguments);
        this.index = 0;
        this.additionalHeight = 0;
        this.showIconAfter = false;
        this.mobileView = false;
        this.showIconAfterOnHover = false;
        this.selected = false;
    }
    static { this.tagName = 'inch-token-item-base'; }
    static { this.styles = tokenItemBaseStyle; }
    firstUpdated() {
        subscribe(this, fromEvent(this, 'click').pipe(tap((event) => this.onClickToken(event))), {
            requestUpdate: false,
        });
    }
    render() {
        appendClass(this, {
            'show-after-icon': this.showIconAfter,
            'icon-after_on-hover': this.showIconAfter && this.showIconAfterOnHover,
            mobile: this.mobileView,
            selected: this.selected,
        });
        this.style.setProperty('--additional-height', `${this.additionalHeight}px`);
        const iconAfterStyle = this.iconAfterStyle ?? {};
        const chainIds = this.chainIds ?? [this.tokenChainId];
        const animationDelayMillisecond = (this.index + 10) * 100;
        return html `
      <div class="grid">
        ${this.renderTokenIcon()} ${this.renderTokenName()} ${this.renderTokenNetworkText()}
        <inch-token-balance
          class="token-balance primary-text token-balance-view"
          endTextAlign
          .symbol="${this.symbol}"
          .chainIds="${chainIds}"
          .walletAddress="${this.walletAddress}"
          .skeletonAnimationDelayMillisecond="${animationDelayMillisecond}"
        ></inch-token-balance>
        <inch-token-fiat-balance
          class="token-fiat-balance secondary-text token-balance-view"
          endTextAlign
          .symbol="${this.symbol}"
          .chainIds="${chainIds}"
          .walletAddress="${this.walletAddress}"
          .skeletonAnimationDelayMillisecond="${animationDelayMillisecond}"
        ></inch-token-fiat-balance>
        ${when(this.showIconAfter, () => html `
            <div class="icon-after" @click="${(event) => this.onClickIconAfter(event)}">
              <inch-icon
                style="${styleMap(iconAfterStyle)}"
                icon="${this.iconAfterName}"
                .props="${this.iconAfterProps}"
              ></inch-icon>
            </div>
          `)}
      </div>
      <slot></slot>
    `;
    }
    renderTokenIcon() {
        if (!this.symbol) {
            return html ` <inch-loader-spinner class="token-icon" size="40"></inch-loader-spinner> `;
        }
        return html `
      <inch-token-icon
        class="token-icon"
        symbol="${this.symbol}"
        chainId="${this.tokenChainId}"
        address="${this.tokenAddress}"
        size="40"
      ></inch-token-icon>
    `;
    }
    renderTokenName() {
        if (!this.tokenNameText) {
            const animationDelayMillisecond = this.index * 100;
            return html ` <inch-loader-skeleton
        class="token-name primary-text"
        .animationDelayMillisecond="${animationDelayMillisecond}"
      ></inch-loader-skeleton>`;
        }
        return html `
      <inch-marquee class="token-name primary-text">${this.tokenNameText}</inch-marquee>
    `;
    }
    renderTokenNetworkText() {
        if (!this.tokenNetworkText) {
            const animationDelayMillisecond = this.index * 100;
            return html `<inch-loader-skeleton
        class="token-networks secondary-text"
        .animationDelayMillisecond="${animationDelayMillisecond}"
      ></inch-loader-skeleton>`;
        }
        return html ` <div class="token-networks secondary-text">${this.tokenNetworkText}</div>`;
    }
    onClickIconAfter(event) {
        event.stopPropagation();
        event.preventDefault();
        dispatchEvent(this, 'onClickIconAfter', null);
    }
    onClickToken(event) {
        event.stopPropagation();
        event.preventDefault();
        dispatchEvent(this, 'onClickToken', null);
    }
};
__decorate([
    property({ type: Array, attribute: false }),
    __metadata("design:type", Array)
], TokenItemBaseElement.prototype, "chainIds", void 0);
__decorate([
    property({ type: Object, attribute: false }),
    __metadata("design:type", Object)
], TokenItemBaseElement.prototype, "iconAfterStyle", void 0);
__decorate([
    property({ type: Object, attribute: false }),
    __metadata("design:type", Object)
], TokenItemBaseElement.prototype, "iconAfterProps", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", Number)
], TokenItemBaseElement.prototype, "tokenChainId", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String)
], TokenItemBaseElement.prototype, "tokenAddress", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String)
], TokenItemBaseElement.prototype, "tokenNameText", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", Object)
], TokenItemBaseElement.prototype, "tokenNetworkText", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String)
], TokenItemBaseElement.prototype, "symbol", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String)
], TokenItemBaseElement.prototype, "walletAddress", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String)
], TokenItemBaseElement.prototype, "iconAfterName", void 0);
__decorate([
    property({ type: Number, attribute: false }),
    __metadata("design:type", Object)
], TokenItemBaseElement.prototype, "index", void 0);
__decorate([
    property({ type: Number, attribute: false }),
    __metadata("design:type", Object)
], TokenItemBaseElement.prototype, "additionalHeight", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Object)
], TokenItemBaseElement.prototype, "showIconAfter", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Object)
], TokenItemBaseElement.prototype, "mobileView", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Object)
], TokenItemBaseElement.prototype, "showIconAfterOnHover", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Object)
], TokenItemBaseElement.prototype, "selected", void 0);
TokenItemBaseElement = __decorate([
    customElement(TokenItemBaseElement.tagName)
], TokenItemBaseElement);
export { TokenItemBaseElement };
//# sourceMappingURL=token-item-base.element.js.map